@if (editable()) {
  <span class="price-box price-box--edit">
    @if (nullable()) {
      <i
        aria-hidden="true"
        (click)="toggleNullableNet()"
        class="pi price-box__toggle"
        [class.pi-minus]="isNull()"
        [class.pi-check-circle]="!isNull()"
      ></i>
    }
    @if (!isNull()) {
      <input
        pInputText
        [disabled]="isNetDisabled()"
        [ngModel]="net | currency"
        (ngModelChange)="net = $event ? $event : ''"
        (keyup)="calculateTotals(); netValueChanged()"
        (keyup.enter)="saveEmit()"
        type="text"
        inputmode="decimal"
        step="0.5"
        class="form-control price-box__input"
        data-cy="net-price"
      />
      <input
        pInputText
        [disabled]="isMarginAndTotalDisabled()"
        [ngModel]="margin | currency"
        (ngModelChange)="margin = parseNewMargin($event)"
        (keyup)="calculateTotals(); marginValueChanged()"
        (keyup.enter)="saveEmit()"
        type="text"
        inputmode="decimal"
        step="0.5"
        class="form-control price-box__input"
        data-cy="margin-price"
      />
      <i class="pi pi-chevron-right price-box__sep"></i>
      <input
        pInputText
        [disabled]="isMarginAndTotalDisabled()"
        [ngModel]="total | currency"
        (ngModelChange)="total = $event"
        (keyup)="calculateMarginFromTotal()"
        (keyup.enter)="saveEmit()"
        type="text"
        inputmode="decimal"
        step="0.5"
        class="form-control price-box__input"
        data-cy="total-price"
      />
      @if (multiplier()) {
        <i class="pi pi-angle-double-right price-box__sep"></i>
        <input
          pInputText
          [disabled]="isMarginAndTotalDisabled()"
          [ngModel]="multipliedTotal | currencyRound"
          (ngModelChange)="multipliedTotal = $event"
          (change)="calculateMarginFromMultipliedTotal()"
          type="text"
          inputmode="decimal"
          step="0.5"
          class="form-control price-box__input"
          data-cy="multiplied-total-price"
        />
      }
    }
  </span>
} @else if (shouldDisplayDash()) {
  <span class="price-box">&mdash;</span>
} @else if (!displayMargin()) {
  <span class="price-box">{{ net | currency }}</span>
} @else {
  <span class="price-box">
    <span class="price-box__value">{{ net | currency }}</span>
    <span class="price-box__value">{{ margin | forceSign }}</span>
    <i class="pi pi-chevron-right price-box__sep"></i>
    <span class="price-box__total">{{ total | currency }}</span>
    @if (multiplier()) {
      <i class="pi pi-angle-double-right price-box__sep"></i>
      <span class="price-box__total price-box__total--grand">{{
        multipliedTotal | currencyRound
      }}</span>
    }
  </span>
}
